import { MatTableDataSource } from '@angular/material/table';
import { AfterViewInit, Component, DestroyRef, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ServicesService } from 'src/services/services.service';
import { MatSort } from '@angular/material/sort';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, tap, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { SocketService } from 'src/services/socket.service';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { forkJoin } from 'rxjs';


export interface EventElement {
  id: string;
  reg_id: string;
  mem_id: string;
  name: string;
  mobile: string;
  tic_category: any;
  category: any;
  city: string;
  // whatsapp_status: string;
  action: any;
  image: any;
  date: any;
  time: any;
  point: any;
  // id_proof: any;
  state: any;
  address: any;
  field1: any;
  field2: any;
  field3: any;
  field4: any;
  field5: any;
  field6: any;
  field7: any;
  field8: any;
  field9: any;
  barcode: any;
  payment_status: any;
  transaction_id: any;
  allowed_person: any;
  created_by: any;
}

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  standalone: false
})

export class ReportComponent {
  displayedColumns: string[] = [
    'mem_id',
    'date',
    'time',
    'image',
    // 'id_proof',
    'name',
    'mobile',
    'tic_category',
    'city',
    'state',
    'address',
    'field1',
    'field2',
    'field3',
    'field4',
    'field5',
    'field6',
    'field7',
    'field8',
    'field9',
    'barcode',
    'payment_status',
    'transaction_id',
    'allowed_person',
    'created_by',
    // 'whatsapp_status',
    // 'send_whatsapp',
    'action',
  ];


  ELEMENT_DATA: EventElement[] = [];
  event_result: any;
  user_id: any;
  event_id: any;
  report_type: any = 'checkin';
  selectedStyle = 'bold';

  readonly range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  // Model for two-way binding with ngModel
  rangeStart: Date | null = null;
  rangeEnd: Date | null = null;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<EventElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  getresult: any;
  mem_id: any;
  total_reg: any;
  total_checkin: any;
  total_checkout: any;
  total_notvisited: any;

  showEventAdvancedSearch = false;
  filteredPointsData: any;
  getUniqueTicket: any;
  Enable_Delete: boolean = false;

  events: string[] = [];



  searchCriteria = {
    point: new FormControl(''),
    tic_category: new FormControl<any>(null),
    date: new FormControl(new Date()),
    reg_date: new FormControl(''),
  };
  setting_data: any;
  contact_privacy: any;

  onEventSearchButtonClick() {
    this.Get_Report(this.report_type);
  }

  constructor(
    private service: ServicesService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private datePipe: DatePipe,
    private socketservice: SocketService
  ) {
    this.socketservice.Refresh()
      .pipe(takeUntilDestroyed(inject(DestroyRef)))
      .subscribe((action: boolean) => {
        if (action === true) {
          this.Refresh_Get_Report(this.report_type);
        }
      });
    this.getTicketCategory();
  }

  ngAfterViewInit(): void {
    const user = sessionStorage.getItem('User');
    this.event_id = window.sessionStorage.getItem('Event_ID');

    this.Get_Report(this.report_type);
    this.dataSource.paginator = this.paginator;
    this.Get_Scanning_Point();

    if ((user === 'superadmin' && this.event_id) || user === 'admin') {
      this.Enable_Delete = true;
    }

    this.range.valueChanges
      .pipe(
        tap(({ start, end }) => {
          if (start && end) {
            this.onEventSearchButtonClick();
          }
        }),
        takeUntilDestroyed(this.destoryRef)
      )
      .subscribe();
  }

  transactions(): void {
    this.router.navigate(['/admin/Transactions']);
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  toggleEventAdvancedSearch(): void {
    this.showEventAdvancedSearch = !this.showEventAdvancedSearch;

    if (!this.showEventAdvancedSearch) {
      this.searchCriteria = {
        point: new FormControl(''),
        tic_category: new FormControl(''),
        date: new FormControl(new Date()),
        reg_date: new FormControl('')
      };

      this.dataSource.data = this.ELEMENT_DATA;
    }
  }

  /**
   * Build payload based on report type
   * Different APIs require different parameters
   */
  private buildPayload(reportType: string): any {
    const formattedStart = this.datePipe.transform(this.range.value.start, 'yyyy-MM-dd') || '';
    const formattedEnd = this.datePipe.transform(this.range.value.end, 'yyyy-MM-dd') || '';
    const ticketCategoryData = this.searchCriteria.tic_category.value;
    const point = this.searchCriteria.point.value || '';
    const categoryId = ticketCategoryData?.category_id || '';

    const commonPayload = {
      event_id: this.event_id,
      point: point,
      date: formattedStart,
      tic_category: ticketCategoryData?.category || ''
    };

    const registrationPayload = {
      event_id: this.event_id,
      reg_date: formattedStart,
      category_id: categoryId
    };

    const countPayload = {
      event_id: this.event_id,
      point: point,
      date: formattedStart,
      reg_date: formattedStart,
      category_id: categoryId,
      tic_category: ticketCategoryData?.category || ''
    };

    switch (reportType) {
      case 'checkin':
        return { ...commonPayload, end_date: formattedEnd };
      case 'checkout':
        return { ...commonPayload, end_date: formattedEnd };
      case 'notvisited':
        return registrationPayload;
      default:
        return registrationPayload;
    }
  }

  /**
   * Get report count data
   */
  private getReportCount(): any {
    const countPayload = {
      event_id: this.event_id,
      point: this.searchCriteria.point.value || '',
      date: this.datePipe.transform(this.range.value.start, 'yyyy-MM-dd') || '',
      reg_date: this.datePipe.transform(this.range.value.start, 'yyyy-MM-dd') || '',
      category_id: this.searchCriteria.tic_category.value?.category_id || '',
      tic_category: this.searchCriteria.tic_category.value?.category || ''
    };

    return this.service.getReportCount(countPayload);
  }

  /**
   * Get report data based on type
   */
  private getReportData(reportType: string): any {
    const payload = this.buildPayload(reportType);

    switch (reportType) {
      case 'checkin':
        return this.service.getCheckins(payload);
      case 'checkout':
        return this.service.getCheckouts(payload);
      case 'notvisited':
        return this.service.getNotVisited(payload);
      case 'all':
      default:
        return this.service.getRegistrationData(this.event_id, '', '');
    }
  }

  /**
   * Map raw data to EventElement interface
   */
  private mapDataToElements(items: any[]): EventElement[] {
    if (!items || items.length === 0) {
      return [];
    }

    return items.map(item => ({
      id: item.id,
      reg_id: item.reg_id,
      mem_id: item.mem_id,
      image: `https://aieventzo.com/upload/${this.event_id}/images/${item.image}`,
      name: item.name,
      city: item.city,
      point: item.point,
      date: item.date,
      time: item.time,
      state: item.state,
      address: item.address,
      mobile: this.contact_privacy === 'public' ? item.mobile : '',
      tic_category: item.tic_category,
      category: item.category,
      field1: item.field1,
      field2: item.field2,
      field3: item.field3,
      field4: item.field4,
      field5: item.field5,
      field6: item.field6,
      field7: item.field7,
      field8: item.field8,
      field9: item.field9,
      barcode: item.barcode,
      payment_status: item.payment_status,
      transaction_id: item.transaction_id,
      allowed_person: item.allowed_person,
      created_by: item.created_by,
      action: item.event_id
    }));
  }

  /**
   * Update displayed columns based on report type
   */
  private updateDisplayedColumns(reportType: string): void {
    const pointIndex = this.displayedColumns.indexOf('point');
    const shouldShowPoint = reportType !== 'all';

    if (shouldShowPoint && pointIndex === -1) {
      this.displayedColumns.splice(3, 0, 'point');
    } else if (!shouldShowPoint && pointIndex !== -1) {
      this.displayedColumns.splice(pointIndex, 1);
    }
  }

  /**
   * Load user privacy settings
   */
  private loadUserSettings(): void {
    this.service.getsetting(this.event_id)
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe(
        (data: any) => {
          this.setting_data = data.data;
          this.contact_privacy = this.setting_data?.[0]?.contact_privacy || 'private';

          const user = sessionStorage.getItem('User');
          if (user === 'superadmin') {
            this.contact_privacy = 'public';
          }
        },
        (error) => {
          console.error('Error loading settings:', error);
          this.contact_privacy = 'private';
        }
      );
  }

  /**
   * Get report data with proper error handling
   */
  Get_Report(reportType: string): void {
    this.updateDisplayedColumns(reportType);
    this.ELEMENT_DATA = [];
    this.spinner.show();

    // Load settings first
    this.loadUserSettings();

    // Fetch both count and report data
    forkJoin({
      count: this.getReportCount(),
      data: this.getReportData(reportType)
    }).pipe(
      takeUntilDestroyed(this.destoryRef),
      finalize(() => this.spinner.hide())
    ).subscribe(
      (result: any) => {
        this.handleReportCountResponse(result.count);
        this.handleReportDataResponse(result.data);
      },
      (error) => {
        console.error('Error fetching report data:', error);
        this.spinner.hide();
        this.toastr.error('Failed to load report data');
      }
    );
  }

  /**
   * Handle report count response
   */
  private handleReportCountResponse(data: any): void {
    if (data) {
      this.total_reg = data.total_reg || 0;
      this.total_checkin = data.total_checkin || 0;
      this.total_checkout = data.total_checkout || 0;
      this.total_notvisited = data.total_notvisited || 0;
    }
  }

  /**
   * Handle report data response
   */
  private handleReportDataResponse(data: any): void {
    if (data && data.result) {
      this.ELEMENT_DATA = this.mapDataToElements(data.result);
    }

    this.dataSource = new MatTableDataSource<EventElement>(this.ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const normalizedFilter = filter.trim().toLowerCase();

      // 🔹 Default full row search (existing behavior)
      const fullDataString = Object.values(data).join(' ').toLowerCase();
      if (fullDataString.includes(normalizedFilter)) {
        return true;
      }

      // 🔹 Special logic ONLY for name
      const name = (data.name || '').toLowerCase();
      const searchTerms = normalizedFilter.split(' ').filter(term => term);

      return searchTerms.every(term => name.includes(term));
    };
  }

  /**
   * Refresh report data (typically called from socket service)
   */
  Refresh_Get_Report(reportType: string): void {
    this.Get_Report(reportType);
  }

  Get_Scanning_Point(): void {
    this.service.getpoints()
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe(
        (data: any) => {
          this.filteredPointsData = data.data || [];
        },
        (error) => {
          console.error('Error loading scanning points:', error);
        }
      );
  }

  getTicketCategory(): void {
    const eventId = window.sessionStorage.getItem('Event_ID');
    if (!eventId) {
      console.warn('Event ID not found in session storage');
      return;
    }

    this.service.get_ticket_category(eventId)
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe(
        (data: any) => {
          this.getUniqueTicket = data.data || [];
        },
        (error) => {
          console.error('Error loading ticket categories:', error);
        }
      );
  }

  onClearEventFilters(): void {
    this.searchCriteria.point.setValue('');
    this.searchCriteria.tic_category.setValue('');
    this.range.get('start')?.setValue(null);
    this.range.get('end')?.setValue(null);
  }

  applyEventSearchFilters(): void {
    const formattedRegDate = this.datePipe.transform(this.searchCriteria.reg_date.value, 'yyyy-MM-dd');

    const filteredData = this.ELEMENT_DATA.filter(item =>
      (!this.searchCriteria.point?.value ||
        item.point?.toString().toLowerCase().includes(this.searchCriteria.point.value.toLowerCase())) &&
      (!this.searchCriteria.tic_category?.value ||
        item.tic_category?.toString().toLowerCase().includes(this.searchCriteria.tic_category.value.toLowerCase())) &&
      (!this.searchCriteria.date?.value ||
        (formattedRegDate && item.date === formattedRegDate))
    );

    this.dataSource.data = filteredData;
  }

  /**
   * Delete report record with confirmation
   */
  DeleteReport(regId: string, id: string, type: string): void {
    const isRegistration = type === 'all' || type === 'notvisited';
    const confirmMessage = isRegistration
      ? 'Are you sure you want to delete this registration?'
      : 'Are you sure you want to delete this attendance?';

    if (!window.confirm(confirmMessage)) {
      return;
    }

    if (isRegistration) {
      this.service.delete_registration(regId)
        .pipe(takeUntilDestroyed(this.destoryRef))
        .subscribe(
          () => {
            this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.reg_id !== regId);
            this.dataSource.data = this.ELEMENT_DATA;
            this.toastr.success('Registration deleted successfully');
          },
          (error) => {
            console.error('Error deleting registration:', error);
            this.toastr.error('Failed to delete registration');
          }
        );
    } else {
      this.service.delete_attendance(id, type)
        .pipe(takeUntilDestroyed(this.destoryRef))
        .subscribe(
          () => {
            this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.id !== id);
            this.dataSource.data = this.ELEMENT_DATA;
            this.toastr.success('Attendance deleted successfully');
          },
          (error) => {
            console.error('Error deleting attendance:', error);
            this.toastr.error('Failed to delete attendance');
          }
        );
    }
  }

  /**
   * Download file utility
   */
  private downloadFile(data: any, filename: string, contentType: string): void {
    const blob = new Blob([data], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  /**
   * Export report data to CSV
   */
  exportTable(reportType: string): void {
    const formattedStart = this.datePipe.transform(this.range.value.start, 'yyyy-MM-dd');
    const formattedEnd = this.datePipe.transform(this.range.value.end, 'yyyy-MM-dd');
    const ticketCategoryData = this.searchCriteria?.tic_category?.value;
    console.log(ticketCategoryData);

    const exportPayload = {
      type: reportType,
      point: this.searchCriteria?.point?.value || '',
      category: ticketCategoryData?.category || '',
      category_id: ticketCategoryData?.category_id || '',
      start_date: formattedStart || '',
      end_date: formattedEnd || ''
    };

    this.service.export(exportPayload)
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe(
        (response: any) => {
          this.downloadFile(response, `${reportType}_${Date.now()}.csv`, 'text/csv');
          this.toastr.success('Report exported successfully');
        },
        (error) => {
          console.error('Error exporting report:', error);
          this.toastr.error('Failed to export report');
        }
      );
  }

  /**
   * Navigate to registered users
   */
  reg(): void {
    this.router.navigate(['/admin/Registered Users']);
  }

}